export class MultiselectItem {
    constructor(public Item: any, public Selected: boolean) {}
}

export interface ISelectionChangedEvent {
    items: MultiselectItem[];
    selectedItems: any[];
}
